/**
 * `mode: 'push'` keeps the current entry in history (`location.assign`) instead of
 * replacing it — used for the native-handoff retry so the tap that triggers it carries
 * user activation and the user can return to the handoff screen if the hop fails again.
 */
export const redirectToUrl = (url: URL | string, mode: 'replace' | 'push' = 'replace'): void => {
  if (mode === 'push') {
    window.location.assign(url)
  } else {
    window.location.replace(url)
  }
}
